// Errors Actions
import * as helpers from '@/mixins/helperFunctions.js'

export const setErrorsList = ({ commit }, payload) => {
  if (payload) {
    let beErrorsList = []
    // console.warn('beError type:', typeof payload)
    // console.warn('beError:', payload)
    if (typeof payload === 'string') {
      beErrorsList = payload.split(':')
    } else {
      for (let err in payload) {
        for (let i in payload[err]) {
          beErrorsList.push(payload[err][i])
        }
      }
    }
    commit('setErrorsList', beErrorsList)
  } else {
    commit('resetErrorsList')
  }
}

// ***** General error handling
export const errorHandling = ({ dispatch }, payload) => {
  helpers.ktNotify({
    type: 'error',
    text: payload.msg
  })
  dispatch('setErrorsList', payload.err.response.data.message)
  throw new Error('Error')
}

export const resetAllErrors = ({ commit, dispatch }, payload) => {
  commit('resetValidationErrors', payload)
  dispatch('setErrorsList')
}
